import { useEffect, useRef, useState, } from 'react';
import { Sheet, SheetRef } from "react-modal-sheet";
import './App.css';

function App() {
  const sheetRef = useRef<SheetRef>(null);
  const snapPoints = [0, 100, 1];
  const [pageIndex, setPageIndex] = useState(0);

  useEffect(() => {
    const onPopState = () => {
      setPageIndex(window.location.search.includes('something') ? 1 : 0);
    };
    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, []);

  if (pageIndex === 1) {
    return (
      <div className="App">
        Page 2
      </div>
    );
  }
  return (
    <div className="App">
      <Sheet ref={sheetRef} isOpen={true} onClose={() => {
        sheetRef.current?.snapTo(1);
      }} snapPoints={snapPoints} initialSnap={1}>
        <Sheet.Container>
          <Sheet.Header />
          <Sheet.Content>
            <div style={{ padding: 20 }}>
              <a href="/?something" onClick={(e) => {
                e.preventDefault();
                window.history.pushState(null, '', '/?something');
                setPageIndex(1);
              }}>Next page</a>
            </div>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop />
      </Sheet>
    </div>
  );
}

export default App;
